import React, { Component } from 'react';
import Validator from 'validatorjs';
import { Col, Form } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';

class ClienteServicesForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules),
    };
  }

  get rules() {
    return {
      costo_hit: ['required', 'string'],
    };
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnChange = (event) => {
    const { name, checked } = event.target;
    const { data } = this.props;

    if (checked === false) {
      const { [name]: checked, ...rest } = data.servicios;

      const newDataServices = {
        servicios: rest,
      };

      this.props.onFormDataChange({
        data: {
          ...data,
          ...newDataServices,
        },
        step: this.props.step,
        isValid: Object.keys(newDataServices.servicios).length !== 0,
      });
    } else {
      const newDataServices = {
        servicios: {
          ...data.servicios,
          [name]: checked,
        },
      };

      this.props.onFormDataChange({
        data: {
          ...data,
          ...newDataServices,
        },
        step: this.props.step,
        isValid: Object.keys(newDataServices.servicios).length !== 0,
      });
    }
  };

  handleOnEsquemaChange = (event) => {
    const { value } = event.target;
    const { data } = this.props;

    this.props.onFormDataChange({
      data: {
        ...data,
        esquema: parseInt(value),
      },
      step: this.props.step,
      isValid: true,
    });
  };

  handleOnDataChange = (value) => {
    const { data } = this.props;

    const validator = this.validate(value);

    this.props.onFormDataChange({
      data: {
        ...data,
        metadata: {
          ...data.metadata,
          ...value,
        },
      },
      step: this.props.step,
      isValid: validator.passes(),
    });
  };

  render() {
    const {
      data: { servicios = {}, esquema, metadata = {} },
    } = this.props;
    const { validator } = this.state;

    return (
      <Form>
        <Form.Group controlId="cliente_externo">
          <Form.Check
            type="checkbox"
            name="cliente_externo"
            label="Cliente integrado de forma externa (Limitado)"
            checked={servicios.cliente_externo || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="api_integration">
          <Form.Check
            type="checkbox"
            name="api_integration"
            label="Cliente integrado por API"
            checked={servicios.api_integration || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="generacion_pdf">
          <Form.Check
            type="checkbox"
            name="generacion_pdf"
            label="Generación representación impresa"
            checked={servicios.generacion_pdf || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="envio_de_comprobantes">
          <Form.Check
            type="checkbox"
            name="envio_de_comprobantes"
            label="Envio de comprobantes a clientes"
            checked={servicios.envio_de_comprobantes || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="almacenamiento_regular">
          <Form.Check
            type="checkbox"
            name="almacenamiento_regular"
            label="Almacenamiento de XML y PDF (3 meses)"
            checked={servicios.almacenamiento_regular || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="almacenamiento_ilimitado">
          <Form.Check
            type="checkbox"
            name="almacenamiento_ilimitado"
            label="Almacenamiento ilimitado"
            checked={servicios.almacenamiento_ilimitado || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="portal_receptores">
          <Form.Check
            type="checkbox"
            name="portal_receptores"
            label="Portal receptores"
            checked={servicios.portal_receptores || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="administrar_pagos">
          <Form.Check
            type="checkbox"
            name="administrar_pagos"
            label="Administrar pagos"
            checked={servicios.administrar_pagos || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="excel_conceptos">
          <Form.Check
            type="checkbox"
            name="excel_conceptos"
            label="Subir excel de conceptos"
            checked={servicios.excel_conceptos || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="excel_comercioexterior">
          <Form.Check
            type="checkbox"
            name="excel_comercioexterior"
            label="Subir excel de mercancías para Comercio Exterior"
            checked={servicios.excel_comercioexterior || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="excel_cartaporte">
          <Form.Check
            type="checkbox"
            name="excel_cartaporte"
            label="Subir excel de ubicaciones y mercancías para Carta Porte"
            checked={servicios.excel_cartaporte || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="factura_observaciones">
          <Form.Check
            type="checkbox"
            name="factura_observaciones"
            label="Agregar observaciones al crear factura"
            checked={servicios.factura_observaciones || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="claveprodserv_requerido">
          <Form.Check
            type="checkbox"
            name="claveprodserv_requerido"
            label="Clave producto/servicio requerida en conceptos"
            checked={servicios.claveprodserv_requerido || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="sector_primario">
          <Form.Check
            type="checkbox"
            name="sector_primario"
            label="Emisión de facturas para sector primario"
            checked={servicios.sector_primario || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <div className="py-3">
          <strong className="text-info">MÓDULOS ADICIONALES</strong>
        </div>

        <Form.Group controlId="retenciones">
          <Form.Check
            type="checkbox"
            name="retenciones"
            label="Retenciones"
            checked={servicios.retenciones || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="autofacturacion">
          <Form.Check
            type="checkbox"
            name="autofacturacion"
            label="Servicio de autofacturación"
            checked={servicios.autofacturacion || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="catalogo_cliente">
          <Form.Check
            type="checkbox"
            name="catalogo_cliente"
            label="Catalogo Cliente"
            checked={servicios.catalogo_cliente || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="facturacion_masiva">
          <Form.Check
            type="checkbox"
            name="facturacion_masiva"
            label="Facturación por excel"
            checked={servicios.facturacion_masiva || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="retencion_masiva">
          <Form.Check
            type="checkbox"
            name="retencion_masiva"
            label="Retenciones por excel"
            checked={servicios.retencion_masiva || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="timbrado_sftp">
          <Form.Check
            type="checkbox"
            name="timbrado_sftp"
            label="Timbrado por SFTP"
            checked={servicios.timbrado_sftp || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="socios_de_negocio">
          <Form.Check
            type="checkbox"
            name="socios_de_negocio"
            label="Socios de negocio / Autoemisión"
            checked={servicios.socios_de_negocio || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="prefacturas">
          <Form.Check
            type="checkbox"
            name="prefacturas"
            label="Prefacturas"
            checked={servicios.prefacturas || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="recepcion">
          <Form.Check
            type="checkbox"
            name="recepcion"
            label="Recepción y validación"
            checked={servicios.recepcion || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <div className="py-3">
          <strong className="text-info">MODELO DE NEGOCIO</strong>
        </div>

        <Form.Group controlId="multi_empresa">
          <Form.Check
            type="checkbox"
            name="multi_empresa"
            label="Habilitar multi empresa"
            checked={servicios.multi_empresa || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="multi_emisor">
          <Form.Check
            type="checkbox"
            name="multi_emisor"
            label="Habilitar multi emisor"
            help="Si se habilita multi empresa, se activará en automático esta opción."
            checked={servicios.multi_emisor || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <Form.Group controlId="multi_usuario">
          <Form.Check
            type="checkbox"
            name="multi_usuario"
            label="Habilitar multi usuario"
            checked={servicios.multi_usuario || false}
            onChange={this.handleOnChange}
          />
        </Form.Group>

        <div className="py-3">
          <strong className="text-info">ESQUEMA</strong>
        </div>

        <Form.Group controlId="esquema_prepago">
          <Form.Check
            type="radio"
            name="prepago"
            label="Prepago"
            value={1}
            checked={esquema === 1}
            onChange={this.handleOnEsquemaChange}
          />
        </Form.Group>

        <Form.Group controlId="esquema_postpago">
          <Form.Check
            type="radio"
            name="postpago"
            label="Postpago"
            value={2}
            checked={esquema === 2}
            onChange={this.handleOnEsquemaChange}
          />
        </Form.Group>

        {esquema === 2 && (
          <Col
            xs={12}
            sm={12}
            md={5}
            lg={5}
          >
            <FormControl
              type="number"
              label="Costo Hit"
              name="costo_hit"
              value={metadata.costo_hit}
              validator={validator}
              onChange={this.handleOnDataChange}
            />
          </Col>
        )}
      </Form>
    );
  }
}

export default ClienteServicesForm;
